(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gm-athlete-testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gm-athlete-carousel')) {
  customElements.define('gm-athlete-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.carousel !== 'true' || this.controller) return;
      this.grid = this.querySelector('.gm-athletes__grid--carousel');
      this.prev = this.querySelector('[data-gm-athlete-prev]');
      this.next = this.querySelector('[data-gm-athlete-next]');
      this.position = this.querySelector('[data-gm-athlete-position]');
      if (!this.grid || !this.prev || !this.next) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.grid.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.grid.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.grid);
      this.update();
    }
    stride() {
      const card = this.grid.querySelector('.gm-athletes__card');
      return card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.grid).columnGap) || 0) : 0;
    }
    move(direction) {
      this.grid.scrollBy({ left: direction * this.stride(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    update() {
      if (this.dataset.desktopCards === 'true' && matchMedia('(min-width: 750px)').matches) {
        this.grid.removeAttribute('tabindex');
        if (this.grid.scrollLeft) this.grid.scrollLeft = 0;
        return;
      }
      this.grid.setAttribute('tabindex', '0');
      const total = this.grid.children.length;
      const stride = this.stride();
      const current = stride ? Math.max(0, Math.min(total - 1, Math.round(this.grid.scrollLeft / stride))) : 0;
      this.prev.disabled = current === 0;
      this.next.disabled = current >= total - 1;
      this.position.textContent = (current + 1) + ' / ' + total;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = null;
    }
  });
}

const gmAthleteMobileQuery = matchMedia('(max-width: 749px)');
const gmAthleteMobilePlacements = new Map();
function gmPlaceAthleteSection(root, placement) {
  if (gmAthleteMobileQuery.matches) {
    if (root.parentNode !== placement.target) placement.target.appendChild(root);
  } else if (root.parentNode !== placement.anchor.parentNode) {
    placement.anchor.after(root);
  }
}
function gmRegisterMobileAthleteSections() {
  document.querySelectorAll('gm-athlete-carousel[data-mobile-after-purchase="true"]').forEach((carousel) => {
    const root = carousel.closest('.shopify-section');
    if (!root || gmAthleteMobilePlacements.has(root)) return;
    const mainContent = root.closest('main') || document;
    const target = mainContent.querySelector('[data-gm-athletes-mobile-target]');
    if (!target) return;
    const anchor = document.createComment('Sportlerstimmen: Desktop-Position');
    root.before(anchor);
    const placement = { anchor, target };
    gmAthleteMobilePlacements.set(root, placement);
    gmPlaceAthleteSection(root, placement);
  });
}
gmRegisterMobileAthleteSections();
document.addEventListener('DOMContentLoaded', gmRegisterMobileAthleteSections);
document.addEventListener('shopify:section:load', gmRegisterMobileAthleteSections);
document.addEventListener('shopify:section:unload', (event) => {
  gmAthleteMobilePlacements.forEach((placement, root) => {
    if (root === event.target || !placement.target.isConnected) {
      placement.anchor.remove();
      gmAthleteMobilePlacements.delete(root);
    }
  });
});
gmAthleteMobileQuery.addEventListener('change', () => {
  gmAthleteMobilePlacements.forEach((placement, root) => {
    if (!placement.anchor.isConnected || !placement.target.isConnected) {
      gmAthleteMobilePlacements.delete(root);
      return;
    }
    gmPlaceAthleteSection(root, placement);
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gymmonky-how-to-use-card"] && !Shopify.designMode) return;
  try {
    
['pointerover','touchstart','focusin'].forEach(function(type){
  document.addEventListener(type,function(event){
    var trigger=event.target.closest&&event.target.closest('[data-htu-card-open]');
    if(!trigger){return;}
    var full=trigger.closest('.htu-card').querySelector('.htu-card__full');
    if(full&&full.loading==='lazy'){full.loading='eager';}
  },{passive:true});
});
document.addEventListener('click',function(event){
  var open=event.target.closest('[data-htu-card-open]');
  if(open){
    var dialog=open.closest('.htu-card').querySelector('[data-htu-card-dialog]');
    if(dialog&&typeof dialog.showModal==='function'&&!dialog.open){dialog.showModal();}
    return;
  }
  var close=event.target.closest('[data-htu-card-close]');
  if(close){
    var dlg=close.closest('dialog');
    if(dlg&&dlg.open){dlg.close();}
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gymmonky-how-to-use-chapter"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('toggle',function(event){
  const details=event.target;
  if(!(details instanceof HTMLDetailsElement)||details.open)return;
  if(!details.matches('[data-htu-tutorial],[data-htu-chapter]'))return;
  details.querySelectorAll('video').forEach(function(video){video.pause();});
},true);
document.addEventListener('shopify:block:select',function(event){
  const tutorial=event.target.closest('[data-htu-tutorial]');
  if(!tutorial)return;
  tutorial.open=true;
  const chapter=tutorial.closest('[data-htu-chapter]');
  if(chapter)chapter.open=true;
});
document.addEventListener('shopify:section:select',function(event){
  const chapter=event.target.querySelector('[data-htu-chapter]');
  if(chapter)chapter.open=true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gymmonky-how-to-use-guide"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const opener=event.target.closest('[data-htu-guide-open]');
  if(opener){
    const dialog=document.getElementById(opener.getAttribute('aria-controls'));
    if(!dialog||dialog.open)return;
    const frame=dialog.querySelector('[data-pdf-url]');
    if(frame&&!frame.hasAttribute('src')){
      const url=frame.dataset.pdfUrl.split('#')[0];
      frame.src=url+'#toolbar=0&navpanes=0&view=FitH';
    }
    dialog.showModal();
    dialog.querySelectorAll('[data-htu-guide-image]').forEach(function(image){
      if(!image.hasAttribute('src'))image.src=image.dataset.src;
    });
    return;
  }
  const zoom=event.target.closest('[data-htu-guide-zoom]');
  if(zoom){
    const dialog=zoom.closest('[data-htu-guide-dialog]');
    const pages=dialog.querySelector('[data-htu-guide-pages]');
    const expanded=zoom.getAttribute('aria-pressed')!=='true';
    zoom.setAttribute('aria-pressed',String(expanded));
    zoom.textContent=expanded?zoom.dataset.labelReduce:zoom.dataset.labelEnlarge;
    pages.dataset.zoom=String(expanded);
    return;
  }
  const closer=event.target.closest('[data-htu-guide-close]');
  if(closer){closer.closest('[data-htu-guide-dialog]').close();return;}
  if(event.target.matches('[data-htu-guide-dialog]')){
    const box=event.target.getBoundingClientRect();
    if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)event.target.close();
  }
});
document.addEventListener('shopify:section:unload',function(event){
  event.target.querySelectorAll('[data-htu-guide-dialog][open]').forEach(function(dialog){dialog.close();});
});

  } catch(e) { console.error(e); }
})();
})();
